// Service to fetch news headlines and generate comprehension drills

export const fetchNewsDrill = async () => {
    try {
        // Using BBC World News RSS via rss2json
        const response = await fetch('https://api.rss2json.com/v1/api.json?rss_url=http://feeds.bbci.co.uk/news/world/rss.xml');
        if (!response.ok) throw new Error('News fetch failed');

        const data = await response.json();
        if (data.status !== 'ok') throw new Error('RSS parsing failed');

        const items = data.items;
        if (!items || items.length === 0) throw new Error('No news items found');

        // Pick a random item
        const item = items[Math.floor(Math.random() * items.length)];

        // Clean up title (remove non-ASCII, etc.)
        // Keep basic punctuation
        const cleanText = (str) => str.toUpperCase().replace(/[^A-Z0-9\s.,?-]/g, '').trim();

        const title = cleanText(item.title);

        // Create a drill
        // "NEWS UPDATE. [TITLE]."
        const text = `NEWS UPDATE. ${title}.`;

        // Generate options using other headlines
        const otherOptions = items
            .filter(i => i.guid !== item.guid)
            .sort(() => Math.random() - 0.5)
            .slice(0, 3)
            .map(i => cleanText(i.title));

        // Ensure we have 4 options (if feed has enough items)
        while (otherOptions.length < 3) {
            otherOptions.push('NO OTHER NEWS');
        }

        const options = [title, ...otherOptions].sort(() => Math.random() - 0.5);

        return {
            id: `news_${Date.now()}`,
            text: text,
            question: 'What was the headline?',
            options: options,
            answer: title,
            difficulty: 'Hard'
        };

    } catch (error) {
        console.warn('News fetch error:', error);
        throw error;
    }
};
